import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminWebServicesService {

  adminwsURL: string;

  constructor(
		private http: HttpClient, 
		private appConfigService: AppConfigService,
  ) { 
		  this.adminwsURL = this.appConfigService.getAdminWSURL();
  }

  postService ( service: string, formData: {}): Observable<any> {
		let httpHeaders = new HttpHeaders();
		httpHeaders = httpHeaders.append( 'accept', 'application/json' );
		httpHeaders = httpHeaders.append( 'Content-Type', 'application/json' );
		const httpOptions = { headers: httpHeaders, withCredentials: true };
    console.log("POST " + this.adminwsURL + service);

    return this.http.post( this.adminwsURL + service, formData, httpOptions );
  }

}
